import { Box, Typography } from '@mui/material'
import React from 'react'

export const Title = (props) => {
  return (
    <Box mb={4}>
      <Typography
        variant='h4'
        className={`bold-text black--text ${props.classes || ''}`}
        align='center'
        {...props}
      >
        {props.children}
      </Typography>
    </Box>
  )
}
